import Vue from 'vue';

export default Vue.directive('focus', {
    inserted: function(el, binding) {
        if (!binding.hasOwnProperty('value') || binding.value) el.focus();
    },
});



// WEBPACK FOOTER //
// ./shared/directives/focus.js